import { Button } from '@connected/ui/components/button';
import { ContentLayout } from '@connected/ui/layouts/content/layout';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import logo from '@/assets/logo.png';

export function NotFound() {
    const { t } = useTranslation('unauth');
    const currentYear = new Date().getFullYear();

    return (
        <div className="min-h-screen flex flex-col justify-between">
            <div className="p-8">
                <Link to="/">
                    <img src={logo} className="h-8 object-fill" />
                </Link>
            </div>
            <ContentLayout className="h-full w-full items-center justify-center gap-3 max-w-none">
                <ContentLayout.Header className="w-full max-w-sm">
                    <ContentLayout.Title className="text-center text-6xl pb-1">
                        404
                    </ContentLayout.Title>
                    <ContentLayout.SubTitle className="text-center text-base font-normal px-3 pb-2">
                        {t('not-found.title')}
                    </ContentLayout.SubTitle>
                </ContentLayout.Header>
                <Button
                    variant="default"
                    className="font-semibold"
                    asChild
                >
                    <Link
                        to="/"
                        className="flex items-center gap-2"
                    >
                        {t('not-found.back-to-home')}
                    </Link>
                </Button>
            </ContentLayout>
            <div className="p-8 text-left">
                &copy; Connected
                {' '}
                {currentYear}
            </div>
        </div>
    );
}
